<mat-card class="p-0">
    <div class="p-16 fx-row align-items-center justify-content-between">
        <div class="fx-column">
            <span class="text bold dark">
                {{'ADMIN.PLANS_TITLE' | translate}}
            </span>
            <span class="text dark">
                {{'ADMIN.PLANS_SUBTITLE' | translate}}
            </span>
        </div>
        <button class="main-button ml-20" (click)="createPlan()" roleBasedElement [roles]="['SUPERADMIN']">
            <div class="fx-row align-items-center justify-content-center">
                <mat-icon class="white mr-5" fontSet="material-icons-outlined">add_circle_outline</mat-icon>
                {{'ACTIONS.CREATE' | translate}}
            </div>
        </button>
    </div>
    <table mat-table [dataSource]="dataSource" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">
        <ng-container matColumnDef="label">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                    {{'PLAN.LABEL' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text main bold">{{plan.label}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span class=" small light bold">
                    {{'PLAN.TYPE' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="main text">{{'PLAN.TYPE_'+plan.type | translate}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="maxVolume">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'PLAN.MAX_VOLUME' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text">{{plan.maxVolume}} Go</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="maxTrademarks">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'PLAN.MAX_TRADEMARKS' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text" *ngIf="plan.maxTrademarks !== undefined">{{plan.maxTrademarks}}</span>
                <span class="text light" *ngIf="plan.maxTrademarks === undefined">N/A</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="maxCases">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'PLAN.MAX_CASES' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text" *ngIf="plan.maxCases !== undefined">{{plan.maxCases}}</span>
                <span class="text light" *ngIf="plan.maxCases === undefined">N/A</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="maxCrawlerUrl">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'PLAN.MAX_CRAWLER_URL' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text" *ngIf="plan.maxCrawlerUrl !== undefined">{{plan.maxCrawlerUrl}}</span>
                <span class="text light" *ngIf="plan.maxCrawlerUrl === undefined">N/A</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="annualPrice">
            <th mat-header-cell *matHeaderCellDef>
                <span class=" small light bold">
                    {{'PLAN.ANNUAL_PRICE' | translate}}
                </span>
            </th>
            <td mat-cell *matCellDef="let plan">
                <span class="text bold">{{plan.annualPrice}} €</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let plan">
                <mat-icon class="main clickable" fontSet="material-icons-outlined"
                    (click)="editPlan(plan)">edit</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let plan; columns: displayedColumns;">
        </tr>
    </table>
    <div class="p-16" *ngIf="loading">
        <span class="text light">{{'ADMIN.LIST_LOADING' | translate}}</span>
    </div>
    <div class="p-16" *ngIf="failed && !loading">
        <span class="text light">{{'ADMIN.LIST_LOADING_FAILED' | translate}}</span>
    </div>
    <div class="p-16" *ngIf="done && !loading && !failed && plans.totalDocs === 0">
        <span class="text light">{{'ADMIN.SEARCH_NO_PLANS' | translate}}</span>
    </div>
    <mat-paginator [length]="plans.totalDocs || 0" [pageSize]="plans.limit || 0"
        [pageIndex]="plans && plans.page ? (plans.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="handlePage($event)">
    </mat-paginator>
</mat-card>